<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading" *ngIf="!notDelivered">{{delivery?.id ? "duplica" : "Nuova"}} consegna {{delivery?.id ? delivery?.id : ""}}</h2>
    <h2 class="title-heading" *ngIf="notDelivered">{{delivery?.id && notDelivered ? "Reorganize the consegna" : ""}} {{ delivery?.id }}</h2>
    <div class="delivery-security" *ngIf="delivery">
      <div class="" *ngIf="(
        (groups.includes('admin') || groups.includes('operation') || groups.includes('partner')) && delivery?.partner?.checkExpertIndentity
      )">
        <label class="toggle-container" for="valetIdentity">
          <input 
            type="checkbox" 
            id="valetIdentity" 
            [(ngModel)]="valetIdentity" 
            (ngModelChange)="onValetIdentityChange(valetIdentity)"
          />
          <span class="toggle-switch"></span>
          VERIFICA DELL'IDENTITÀ VALET
        </label>
      </div>

      <div class="" *ngIf="(
        (groups.includes('admin') || groups.includes('operation') || groups.includes('partner'))
      )">
        <label class="toggle-container" for="deliveryCheck">
          <input 
            type="checkbox" 
            id="deliveryCheck" 
            [(ngModel)]="deliveryCheck.deliveryCodeRequired" 
            (ngModelChange)="onDeliveryCheckChange()"
          />
          <span class="toggle-switch"></span>
          CODICE DI CONSEGNA RICHIESTO
        </label>
      </div>
    </div>
  </div>
</section>

<section id="modificaConsegna" class="content-padding">
  <div class="narrow-wrapper">
    <form class="has-cols" [formGroup]="_deliveryForm" *ngIf="_deliveryForm">

      <div class="delivery-colle-data-box">
        <fieldset>
          <legend>SCELTA DEL SERVIZIO:</legend>
          <div class="col-40 grid-element">
            <label>Data consegna{{ _deliveryForm.get("deliveryDate") | required }}</label>
            <input type="date" formControlName="deliveryDate">
            <app-error-html-handler [ctrl]="_deliveryForm.get('deliveryDate')" [messages]="formValidationMsgs.deliveryDate">
            </app-error-html-handler>
          </div>

          <div class="grid-element-full">
            <label>
              Indirizzo destinatario{{ _deliveryForm.get("address") | required }}
              <span class="directions" (click)="directions($event)"> <i class="fas fa-directions fa-2x"></i>
              </span>
            </label>
            <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode"
              [control]="_deliveryForm.get('address')">
            </app-google-maps-search>
            <app-error-html-handler [ctrl]="_deliveryForm.get('address')" [messages]="formValidationMsgs.address">
            </app-error-html-handler>
          </div>

          <div class="col-40 grid-element">
            <label><!--Id user--></label>
            <input type="hidden" formControlName="createdUser" >
          </div>      
          <br class="clear">

          <div class="col-48 grid-element" formGroupName="partner" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label>Partner{{ _deliveryForm.get('partner').get('id') | required }}</label>
            <select id="selezionePartner" type="text" formControlName="id" (change)="handlePartnerChangeDropDown($event.target.value)">
              <option disabled [value]="null"></option>
              <option *ngFor="let partner of partners" [value]="partner.id"
                [selected]="delivery && delivery.partner && delivery.partner.id == partner.id">{{partner.businessName}}
              </option>
            </select>
            <app-error-html-handler [ctrl]="_deliveryForm.get('partner').get('id')"
              [messages]="formValidationMsgs.partner.id">
            </app-error-html-handler>
          </div> 

          <div class="col-48 grid-element">
            <label>Servizio</label>
            <select name="" id="" (change)=handleServiceChange($event.target.value) formControlName="service">
              <option value="null" selected disabled></option>
              <option value="{{service?.service?.id}}" *ngFor="let service of selectedPartnerServices" [disabled]="service?.service?.pricingModel === 'sales' && (groups.includes('partner'))">{{service?.service?.serviceName}}</option>
            </select>
          </div>

           <!-- New Version of start and end time -->
           <div class="col-48 grid-element" *ngIf="showStartEndTime">
            <label>Start and End Time</label>
            <div class="time-range">
              <div>
                <input type="time" formControlName="startTime" (change)="handleStartTimeChange($event.target.value)">
              </div>
              <div style="text-align: center;">&nbsp;-&nbsp;</div>
              <div>
                <input type="time" formControlName="endTime" (change)="handleEndTimeChange($event.target.value)">
              </div>
            </div>
          </div>
          <!-- New Version of start and end time -->

        </fieldset>
      </div>


      <!--
      <div class="order-management-box" style="margin-top: 15px;">
        <fieldset>
          <legend>GESTIONE DELL'ORDINE:</legend>
          <div class="col-48 grid-element">
            <label for="payAtDelivery"></label>
            <label class="original-label">
              <input type="checkbox" name="payAtDelivery" formControlName="payAtDelivery">
              Pagamento alla consegna
            </label>
          </div>

          <div class="col-48 grid-element" [ngClass]="{'hidden': !_deliveryForm.get('payAtDelivery').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label>Pagamento alla consegna prezzo{{ _deliveryForm.get("payAtDeliveryAmount") | required }}</label>
            <input type="text" formControlName="payAtDeliveryAmount">
            <app-error-html-handler [ctrl]="_deliveryForm.get('payAtDeliveryAmount')" [messages]="formValidationMsgs.payAtDeliveryAmount"> 
            </app-error-html-handler>
          </div>
    
          <div class="col-48 grid-element">
            <label for="tryAndReturn"></label>
            <label class="original-label">
              <input type="checkbox" name="tryAndReturn" formControlName="tryAndReturn">
              Prova e reso del prodotto
            </label>
          </div>
    
          <div class="grid-element-full">
            <label>Prodotto{{ _deliveryForm.get('deliveryProducts').controls[0].controls.product.id | required }}*</label>
            <div formArrayName="deliveryProducts">
              <div class="offer-products"
                *ngFor="let productForm of _deliveryForm.get('deliveryProducts').controls; let i = index">
                <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                  </div>
                  <div class="product-q" formGroupName="product">
                    <div class="porduct-qty">
    
                      <div class="main-product">
                        <ng-select bindLabel="name" bindValue="id" formControlName="id" (change)="handleProductChange(i, $event)">
                          <ng-option *ngFor="let product of products | sortProducts:selectedPartner?.id" [value]="product.id" [disabled]="isOptionDisabled(product)">
                            <b *ngIf="product?.partner?.id == selectedPartner?.id">{{ product.name }}</b>
                            <span *ngIf="product?.partner?.id != selectedPartner?.id || !product?.partner">{{ product.name }}</span>
                          </ng-option>
                        </ng-select>
                      </div>
      
                      <div class="product-quantity">
                        <input type="text" formControlName="quantity" placeholder="Product quantity" (input)="handleProductQuantityChange()">
                      </div>

                      <div *ngIf="showProductImage[i]" class="product-image-wrapper">
                        <img [src]='productImageUrls[i]' class="product-image" alt="" height="50" width="60">
                      </div>
                    </div>
                  </div>
                  <fieldset class="variant-fieldset" *ngIf="showProductVariant[i]">
                    <legend><b>{{ selectedProductsForVariants[i]?.productOptionTitle?.toUpperCase() }}</b></legend>
                    <div class="product-variants">
                      <span 
                        class="chip primary"
                        [ngClass]="{ 'variant-selected': variant === selectedVariants[i] }"
                        *ngFor="let variant of selectedProductsForVariants[i]?.productVariants"
                        (click)="onVariantSelect(i, variant)"
                      >
                        {{ variant?.variantName || "---"}}
                      </span>
                    </div>
                  </fieldset>
                  <app-error-html-handler [ctrl]="productForm.controls.product.controls.id"
                    [messages]="formValidationMsgs.deliveryProducts.product.id">
                  </app-error-html-handler>
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button type="button" class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>
        </fieldset>
      </div>
      -->

      <div class="order-management-box" style="margin-top: 15px;">
        <fieldset>
          <legend>GESTIONE DELL'ORDINE:</legend>
          
          <div style="margin-bottom: 10px; margin-top: 15px;">
            <fieldset >
              <legend>OPZIONI DEL PRODOTTO</legend>
              <div class="col-48 grid-element">
                <label for="payAtDelivery"></label>
                <label class="original-label">
                  <input type="checkbox" name="payAtDelivery" formControlName="payAtDelivery">
                  Pagamento alla consegna
                </label>
              </div>

              <div class="col-48 grid-element" [ngClass]="{'hidden': !_deliveryForm.get('payAtDelivery').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <label>Pagamento alla consegna prezzo{{ _deliveryForm.get("payAtDeliveryAmount") | required }}</label>
                <input type="text" formControlName="payAtDeliveryAmount">
                <app-error-html-handler [ctrl]="_deliveryForm.get('payAtDeliveryAmount')" [messages]="formValidationMsgs.payAtDeliveryAmount"> 
                </app-error-html-handler>
              </div>
        
              <div class="col-48 grid-element">
                <label for="tryAndReturn"></label>
                <label class="original-label">
                  <input type="checkbox" name="tryAndReturn" formControlName="tryAndReturn">
                  Prova e reso del prodotto
                </label>
              </div>
              
              <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <label for="isFlexiblePrice"></label>
                <label class="original-label">
                  <input type="checkbox" name="isFlexiblePrice" formControlName="isFlexiblePrice" (change)="handleFlexiblePayment($event)">
                  Prezzo flessibile
                </label>
              </div>
            </fieldset>
          </div>
    
          <div style="margin-bottom: 10px; margin-top: 15px;">
            <div formArrayName="deliveryProducts">
              <div class="offer-products" *ngFor="let productForm of _deliveryForm.get('deliveryProducts').controls; let i = index">
                <fieldset style="margin-bottom: 10px; margin-top: 15px;">
                  <legend>PRODOTTO & QUANTITA</legend>
                  <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                    </div>
                    <div class="product-q" formGroupName="product">
                      <div class="porduct-qty">
                        <div class="grid-element-full-product">
                          <label for="product">Prodotto {{ _deliveryForm.get('productForm.controls.product.controls.id') }}</label>
                          <ng-select 
                            bindLabel="name"
                            bindValue="id" 
                            formControlName="id" 
                            (change)="handleProductChange(i, $event)"
                            [searchable]="true" 
                            [clearable]="true"
                            [virtualScroll]="true"
                            >
                            <ng-option 
                              *ngFor="let product of products | sortProducts:selectedPartner?.id" 
                              [value]="product.id" 
                              [disabled]="isOptionDisabled(product)" 
                            >
                              <b *ngIf="product?.partner?.id == selectedPartner?.id">{{ product.isAlternateProductName ? product.alternateProductName : product.name }}</b>
                              <span *ngIf="product?.partner?.id != selectedPartner?.id || !product?.partner">{{ product.isAlternateProductName ? product.alternateProductName : product.name }}</span>
                            </ng-option>
                          </ng-select>
                          <app-error-html-handler [ctrl]="productForm.controls.product.controls.id"
                            [messages]="formValidationMsgs.deliveryProducts.product.id">
                          </app-error-html-handler>
                        </div>

                        <div class="col-48 grid-element" *ngIf="!isProductPublicPrice[i]">
                          <label for="">Flessibile Prezzo</label>
                          <input 
                            type="number" 
                            step="0.01" 
                            min="0" 
                            formControlName="flexiblePrice"
                            [disabled]="_deliveryForm.get('isFlexiblePrice').value === false" 
                            [readonly]="_deliveryForm.get('isFlexiblePrice').value === false"
                            (input)="handleManualPriceUpdate(i, $event.target.value)"
                          >
                        </div>

                        <div class="col-48 grid-element" *ngIf="isProductPublicPrice[i]">
                          <label for="">PREZZO PUBBLICO</label>
                          <input 
                            type="number" 
                            step="0.01" 
                            min="0" 
                            [value]="productPublicPrice[i]"
                            [disabled]="true" 
                            [readonly]="true"
                          >
                        </div>
        
                        <div class="col-48 grid-element">
                          <label for="quantity">Quantità</label>
                          <input type="number" formControlName="quantity" placeholder="Prodotto Quantità" (input)="handleProductQuantityChange()">
                          <app-error-html-handler [ctrl]="productForm.controls.product.controls.quantity"
                            [messages]="formValidationMsgs.deliveryProducts.product.quantity">
                          </app-error-html-handler>
                        </div>

                        <div class="col-48 grid-element" *ngIf="selectedService?.service?.pricingModel.toLowerCase() === 'sales'">
                          <label class="toggle-container" for="deliveryWithoutCommision">
                            <input 
                              type="checkbox" 
                              id="deliveryWithoutCommision" 
                              formControlName="deliveryWithoutCommision"
                              (change)="setProductValue()"
                            />
                            <span class="toggle-switch"></span>
                            SENZA COMMISSIONE
                          </label>
                        </div>

                        <div *ngIf="showProductImage[i]" class="product-image-wrapper">
                          <img [src]='productImageUrls[i]' class="product-image" alt="" height="50" width="60">
                        </div>
                      </div>
                    </div>
                    <fieldset class="variant-fieldset" *ngIf="showProductVariant[i]">
                      <legend><b>{{ selectedProductsForVariants[i]?.productOptionTitle?.toUpperCase() }}</b></legend>
                      <div class="product-variants">
                        <span 
                          class="chip primary"
                          [ngClass]="{ 'variant-selected': variant === selectedVariants[i] }"
                          *ngFor="let variant of selectedProductsForVariants[i]?.productVariants"
                          (click)="onVariantSelect(i, variant)"
                        >
                          {{ variant?.variantName || "---"}}
                        </span>
                      </div>
                    </fieldset>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button type="button" class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- <div class="order-management-box" style="margin-top: 15px;">
        <fieldset>
          <legend>COMMISSIONE:</legend>

          <div class="col-48 grid-element" *ngIf="selectedService?.service?.pricingModel.toLowerCase() === 'sales'">
            <label class="toggle-container" for="deliveryWithoutCommision">
              <input 
                type="checkbox" 
                id="deliveryWithoutCommision" 
                formControlName="deliveryWithoutCommision"
              />
              <span class="toggle-switch"></span>
              SENZA COMMISSIONE
            </label>
          </div>
        </fieldset>
      </div> -->

      <div class="delivery-colle-data-box" style="margin-top: 15px;">
        <fieldset>
          <legend>DATA DI CONSEGNA E RITIRO:</legend>

          <div class="col-48 grid-element" *ngIf="showPickUpAddress || showProductValue">
            <label>Disponibilità expert{{ _deliveryForm.get("requestExpert") | required }}</label>
            <label class="original-label">
              <!-- <input type="checkbox" formControlName="requestExpert" (click)="handleFlexbileDelivery($event)"> -->
              <input type="checkbox" formControlName="requestExpert">
              Consegna Flessibile
            </label>
          </div>
    
          <div class="col-48 grid-element" *ngIf="!showStartEndTime">
            <label>FASCIA ORARIA CONSEGNA</label>
            <div class="time-range" [ngClass]="{'hidden': !!_deliveryForm.get('requestExpert').value}">
              <div>
                <select (change)=setTime($event.target.value)>
                  <option></option>
                  <option *ngFor="let item of timePeriods | enumToArray" [value]="item.index"
                    [selected]="_deliveryForm.get('fromTime').value == item.name.from && _deliveryForm.get('toTime').value == item.name.to">
                    {{item.index}}
                  </option>
                </select>
              </div>
            </div>
            <div class="time-range" [ngClass]="{'hidden': !_deliveryForm.get('requestExpert').value}">
              <div>
                <input type="time" formControlName="fromTime">
                <app-error-html-handler [ctrl]="_deliveryForm.get('fromTime')" [messages]="formValidationMsgs.fromTime">
                </app-error-html-handler>
              </div>
              <div style="text-align: center;">&nbsp;-&nbsp;</div>
              <div>
                <input type="time" formControlName="toTime">
                <app-error-html-handler [ctrl]="_deliveryForm.get('toTime')" [messages]="formValidationMsgs.toTime">
                </app-error-html-handler>
              </div>
            </div>
          </div>
          <br class="clear">
    
          <div class="col-48 grid-element">
            <label></label>
            <label class="original-label">
              <input type="checkbox" formControlName="isFlexblePickUpTime">
              Flessibile Fascia Oraria Ritiro
            </label>
          </div>
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('partner') || groups.includes('operation')">
            <label>FASCIA ORARIA RITIRO{{ _deliveryForm.get("pickUpTime") | required }}</label>
            <div class="time-range" [ngClass]="{'hidden': !!_deliveryForm.get('isFlexblePickUpTime').value}">
              <div>
                <select formControlName="pickUpTime">
                  <option value="06:00-07:00">06:00-07:00</option>
                  <option value="07:00-08:00">07:00-08:00</option>
                  <option value="08:00-09:00">08:00-09:00</option>
                  <option value="09:00-10:00">09:00-10:00</option>
                  <option value="10:00-11:00">10:00-11:00</option>
                  <option value="11:00-12:00">11:00-12:00</option>
                  <option value="12:00-13:00">12:00-13:00</option>
                  <option value="13:00-14:00">13:00-14:00</option>
                  <option value="14:00-15:00">14:00-15:00</option>
                  <option value="15:00-16:00">15:00-16:00</option>
                  <option value="16:00-17:00">16:00-17:00</option>
                  <option value="17:00-18:00">17:00-18:00</option>
                  <option value="18:00-19:00">18:00-19:00</option>
                  <option value="19:00-20:00">19:00-20:00</option>
                  <option value="20:00-21:00">20:00-21:00</option>
                  <option value="21:00-22:00">21:00-22:00</option>
                </select>
              </div>
            </div>
            <div class="time-range" [ngClass]="{'hidden': !_deliveryForm.get('isFlexblePickUpTime').value}">
              <div>
                <input type="time" [(ngModel)]="pickUpFTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                <div *ngIf="pickUpFTimeError" style="color: red; font-size: small;">Obbligatorio</div>
              </div>
              <div style="text-align: center;">&nbsp;-&nbsp;</div>
              <div>
                <input type="time" [(ngModel)]="pickUpTTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                <div *ngIf="pickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
              </div>
            </div>
            <app-error-html-handler [ctrl]="_deliveryForm.get('pickUpTime')" [messages]="formValidationMsgs.pickUpTime"></app-error-html-handler>
          </div>
          <!-- No Longer Needed -->
          <div class="col-48 grid-element hidden"  *ngIf="groups.includes('admin') || groups.includes('expert') || groups.includes('operation')">
            <label for="deluxyDelivery"></label>
            <label class="original-label">
              <input type="checkbox" name="deluxyDelivery" formControlName="deluxyDelivery">
              Vendita Deluxy
            </label>
          </div> 
          <!-- No Longer Needed -->

        </fieldset>
      </div>

      <div class="expert-salary-section" style="margin-top: 15px;" *ngIf="groups.includes('admin') || groups.includes('operation')">
        <fieldset>
          <legend>SCELTA DEL SALARIO:</legend>

          <div class="col-48 grid-element" formGroupName="expert">
            <label>Valet{{ _deliveryForm.get('expert').get('id') | required }}</label>
            <select id="selezioneExpert" type="text" formControlName="id" (change)=setDeliveryStatus($event.target.value)>
              <option disabled></option>
              <option *ngFor="let expert of experts" [value]="expert.id"
                [selected]="delivery && delivery.expert && delivery.expert.id == expert.id">{{expert.user.surname}}
                {{expert.user.name}}</option>
            </select>
            <app-error-html-handler [ctrl]="_deliveryForm.get('expert').get('id')"
              [messages]="formValidationMsgs.expert.id">
            </app-error-html-handler>
          </div>
          
          <div class="col-48 grid-element">
            <label>Stato consegna{{ _deliveryForm.get("status") | required }}</label>
            <select formControlName="status">
              <option value="null" selected disabled></option>
              <option *ngFor="let item of deliveryStatus | enumToArray" value="{{item.name}}">
                {{deliveryStatusAux.ln('it', item.name)}}
              </option>
            </select>
            <app-error-html-handler [ctrl]="_deliveryForm.get('status')" [messages]="formValidationMsgs.status">
            </app-error-html-handler>
          </div>  

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label>Valet Servizio</label>
            <select formControlName="expertServiceId" (change)="handleValetServiceChange($event.target.value)">
              <option value="null" selected disabled></option>
              <option value="{{service?.id}}" *ngFor="let service of selectedExpertServices">{{service?.service?.serviceName}}</option>
            </select>
            <app-error-html-handler [ctrl]="_deliveryForm.get('status')" [messages]="formValidationMsgs.status">
            </app-error-html-handler>
          </div>

          <!-- Start and end time for calculate expert salary -->
          <div class="col-48 grid-element" *ngIf="showValetStartAndEndTime && (groups.includes('admin') || groups.includes('operation'))">
            <label>Valet Start and End Time</label>
            <div class="time-range">
              <div>
                <input type="time" formControlName="valetStartTime" (change)="handleValetStartTimeChange($event.target.value)">
              </div>
              <div style="text-align: center;">&nbsp;-&nbsp;</div>
              <div>
                <input type="time" formControlName="valetEndTime" (change)="handleValetEndTimeChange($event.target.value)">
              </div>
            </div>
          </div>

          <div class="col-48 grid-element">
            <label>Stato del pagamento{{ _deliveryForm.get("invoicePaymentStatus") | required }}</label>
            <select formControlName="invoicePaymentStatus">
              <option value="null" selected disabled></option>
              <option *ngFor="let item of invoicePaymentStatus | enumToArray" value="{{item.name}}">
                {{invoicePaymentStatusAux.ln('it', item.name)}}
              </option>
            </select>
            <app-error-html-handler [ctrl]="_deliveryForm.get('invoicePaymentStatus')" [messages]="formValidationMsgs.invoicePaymentStatus"></app-error-html-handler>
          </div>  
          <!-- Start and end time for calculate expert salary -->

        </fieldset>
      </div>

      <div class="recipient-sender-info-box" style="margin-top: 15px;" *ngIf="showCustomerInformation">
        <fieldset>
          <legend>INFORMAZIONI DESTINATARIO E MITTENTE:</legend>
          <!-- phone sms field start -->
          <div class="col-48 grid-element" *ngIf="groups.includes('partner') || groups.includes('admin') || groups.includes('operation')">
            <label>SMS telefonici</label>
            <input type="text" formControlName="smsPhoneNo" placeholder="+449878487878">
            <app-error-html-handler [ctrl]="_deliveryForm.get('smsPhoneNo')"
              [messages]="formValidationMsgs.smsPhoneNo">
            </app-error-html-handler>
          </div>
          <!-- <br class="clear"> -->
          <!-- phone sms field end -->

          <div class="col-48 grid-element">
            <label for="existingCustomer"></label>
            <label class="original-label">
              <input type="checkbox" name="existingCustomer" formControlName="existingCustomer" [disabled]="delivery?.id" (change)="handleExistingCustomer($event)">
              CHOOSE EXISTING CUSTOMER
            </label>
          </div>

          <div class="col-48 grid-element" formGroupName="customer" [ngClass]="{'hidden': !_deliveryForm.get('existingCustomer').value}">
            <label>Customer</label>
            <ng-select 
              bindLabel="name" 
              bindValue="id" 
              formControlName="id" 
              (change)="handleCustomerChange($event)"
              [searchable]="true" 
              [clearable]="true"
              [virtualScroll]="true"
              >
              <ng-option *ngFor="let customer of customers" [value]="customer.id">
                {{ customer.user.surname }} {{ customer.user.name }}
              </ng-option>
            </ng-select>
            <app-error-html-handler [ctrl]="_deliveryForm.get('customer').get('id')" [messages]="formValidationMsgs.customer.id"></app-error-html-handler>
          </div>

          <div class="col-48 grid-element" [ngClass]="{'hidden': _deliveryForm.get('existingCustomer').value}">
            <label for="newCustomer"></label>
            <label class="original-label">
              <input type="checkbox" name="newCustomer" [(ngModel)]="newCustomer" [ngModelOptions]="{standalone: true}">
              SAVE CUSTOMER
            </label>
          </div>

          <br class="clear">

          <div class="col-48 grid-element">
            <label>Cognome destinatario{{ _deliveryForm.get("surname") | required }}</label>
            <input type="text" formControlName="surname">
            <app-error-html-handler [ctrl]="_deliveryForm.get('surname')" [messages]="formValidationMsgs.surname">
            </app-error-html-handler>
          </div>
    
          <div class="col-48 grid-element">
            <label>Nome destinatario{{ _deliveryForm.get("name") | required }}</label>
            <input type="text" formControlName="name">
            <app-error-html-handler [ctrl]="_deliveryForm.get('name')" [messages]="formValidationMsgs.name">
            </app-error-html-handler>
          </div>
        
          <div class="col-48 grid-element">
            <label>Citofono {{ _deliveryForm.get("intercom") | required }}</label>
            <input type="text" formControlName="intercom">
            <app-error-html-handler [ctrl]="_deliveryForm.get('intercom')"
              [messages]="formValidationMsgs.intercom">
            </app-error-html-handler>
          </div>
    
          <div class="col-48 grid-element">
            <label>Telefono destinatario{{ _deliveryForm.get("receiverPhone") | required }}</label>
            <input type="text" formControlName="receiverPhone" placeholder="+449878487878">
            <app-error-html-handler [ctrl]="_deliveryForm.get('receiverPhone')"
              [messages]="formValidationMsgs.receiverPhone">
            </app-error-html-handler>
          </div>
    
          <div class="col-48 grid-element">
            <label>Email destinatario{{ _deliveryForm.get("email") | required }}</label>
            <input type="text" formControlName="email">
            <app-error-html-handler [ctrl]="_deliveryForm.get('email')" [messages]="formValidationMsgs.email">
            </app-error-html-handler>
          </div>
    
          <div class="col-48 grid-element">
            <label>Cognome mittente{{ _deliveryForm.get("senderSurname") | required }}</label>
            <input type="text" formControlName="senderSurname">
            <app-error-html-handler [ctrl]="_deliveryForm.get('senderSurname')"
              [messages]="formValidationMsgs.senderSurname">
            </app-error-html-handler>
          </div>
    
          <div class="col-48 grid-element">
            <label>Nome mittente{{ _deliveryForm.get("senderName") | required }}</label>
            <input type="text" formControlName="senderName">
            <app-error-html-handler [ctrl]="_deliveryForm.get('senderName')" [messages]="formValidationMsgs.senderName">
            </app-error-html-handler>
          </div>
          
          <div class="col-48 grid-element">
            <label>Telefono mittente{{ _deliveryForm.get("senderPhone") | required }}</label>
            <input type="text" formControlName="senderPhone">
            <app-error-html-handler [ctrl]="_deliveryForm.get('senderPhone')" [messages]="formValidationMsgs.senderPhone">
            </app-error-html-handler>
          </div>
        </fieldset>
      </div>

      <br class="clear">

      <div class="list" style="margin-top: 15px;">
        <fieldset>
          <legend>LISTINO:</legend>
          <!--Billable field-->
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="billable"></label>
            <label class="original-label">
              <input type="checkbox" name="billable" formControlName="billable" (change)="handleBillable($event)">
              DA FATTURARE
            </label>
          </div>
          <!--Billable field-->

          <!-- <div class="grid-element-full" *ngIf="showPickUpAddress"> -->
          <div class="grid-element-full">
            <label>
              Indirizzo di Ritiro
              <span class="directions" (click)="pickUpDirections($event)"> <i class="fas fa-directions fa-2x"></i>
              </span>
            </label>
            <app-google-maps-search (setAddress)="getPickUpAddress($event)" addressType="geocode"
              [control]="_deliveryForm.get('pickUpAddress')">
            </app-google-maps-search>
          </div>

          <div class="grid-element-full mt-5">
            <span><b>GLI INDIRIZZI DI RITIRO MULTIPLI SONO DISPONIBILI</b></span>
            <br class="clear">
            <button 
              class="btn hvr-shrink center mt-5" 
              *ngIf="selectedPartner && selectedPartner?.isMultiplePickUpAddress && selectedPartner?.pickupAddresses?.length"
              (click)="handleModalBox()"
              type="button"
              >
              SCEGLI L'INDIRIZZO DI RITIRO<i class="ml-10 far fa-save"></i>
            </button>
          </div>

          <div class="col-48 grid-element" *ngIf="showProductValue">
            <label>PRODOTTO Value</label>
            <input type="number" formControlName="productValue" [readonly]="showProductValue">
          </div>
          <div class="col-48 grid-element" *ngIf="showDistanceInput">
            <label>Distance<b>(Km)</b></label>
            <input type="number" formControlName="distance" [readonly]="true" [disabled]="true">
          </div>
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || (groups.includes('operation') && (selectedService?.service?.pricingModel?.toLowerCase() === 'sales'))">
            <label>Prezzo
              <b>{{ showStartEndTime ? "(Worked Hours * Servizio Prezzo)" : "" }}</b>
              <b>{{ showProductValue ? "(Fee % * Product Value)" : "" }}</b>
            </label>
            <input type="text" formControlName="price" [readonly]="true" [disabled]="true">
          </div>
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label>Plus Prezzo</label>
            <input type="number" formControlName="additionalPrice" [readonly]="disableAdditionalPriceInput" [disabled]="disableAdditionalPriceInput">
          </div>

          <br class="clear">

          <!--Payable field-->
          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label for="payable"></label>
            <label class="original-label">
              <input type="checkbox" name="payable" formControlName="payable" (change)="handlePayable($event)">
              DA PAGARE
            </label>
          </div>
          <!--Payable field-->

          <br class="clear">

          <div class="col-48 grid-element" *ngIf="groups.includes('admin')">
            <label>VALET SALARIO</label>
            <input type="number" formControlName="expertSalary" [readonly]="true" [disabled]="true">
          </div>

          <div class="col-48 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <label>VALET SALARIO PLUS MINUS PREZZO</label>
            <input type="number" formControlName="valetAdditionalPrice" [readonly]="disableValetAdditionalPriceInput" [disabled]="disableValetAdditionalPriceInput">
          </div>
          
        </fieldset>
      </div>
      <div class="doc-notes-box" style="margin-top: 15px;">
        <fieldset>
          <legend>DOCUMENTAZIONE E NOTE:</legend>
          <div class="col-48 grid-element">
            <label>Numero DDT{{ _deliveryForm.get("ddtNumber") | required }}</label>
            <input type="text" formControlName="ddtNumber">
            <app-error-html-handler [ctrl]="_deliveryForm.get('ddtNumber')" [messages]="formValidationMsgs.ddtNumber">
            </app-error-html-handler>
          </div>
          <div class="col-48 grid-element">
            <label>DDT{{ _deliveryForm.get("ddtFile") | required }}</label>
            <div *ngIf="delivery?.ddtFile && !removeFile">
              <a style="float: right; width: auto; color: red; cursor: pointer;" (click)="deleteFile();">×</a>
              <a style="cursor: pointer;" (click)="$event.preventDefault(); showDdt(delivery)">
                {{delivery.ddtFile | replace:'-.{4}(\..{3,4})$':'$1'}}
              </a>
            </div>
            <input type="file" name="ddtFile" (change)="onFileSelect($event)" />
            <app-error-html-handler [ctrl]="_deliveryForm.get('ddtFile')" [messages]="formValidationMsgs.ddtFile">
            </app-error-html-handler>
          </div>
          <div class="grid-element-full">
            <label>Note{{ _deliveryForm.get("notes") | required }}</label>
            <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
          </div>
          <div class="grid-element-full" *ngIf="groups.includes('admin') || groups.includes('expert') || groups.includes('operation')">
            <label>Note interne{{ _deliveryForm.get("internalNotes") | required }}</label>
            <textarea formControlName="internalNotes" rows="5" placeholder="Scrivi una nota interna"></textarea>
          </div>
        </fieldset>
      </div>
        <br class="clear">
        <div class="center">
          <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onDuplicate()" 
            [disabled]="!_deliveryForm?.valid || tmpBtnDisabled" *ngIf="(groups.includes('admin') || groups.includes('operation')) || (groups.includes('partner') && ((!delivery?.deluxyDelivery) && (delivery?.status == 'created' || delivery?.status == 'delivered' || delivery?.status == 'notDelivered' || delivery?.status === undefined )))">
            Salva<i class="ml-10 far fa-save"></i>
          </button>
        </div>

      <div class="error-box" style="margin-top: 15px;" *ngIf="getErrorMessages().length > 0">
        <fieldset>
          <legend>CAMPI OBBLIGATORI:</legend>
          <div>
            <ul class="error-list">
              <li *ngFor="let error of getErrorMessages()">
                {{ translateErrorMessage(error) }}
              </li>
            </ul>
          </div>
        </fieldset>
      </div>
      
      </form>
      <br class="clear">
    </div>
  </section>

  <div *ngIf="showAddressModal && selectedPartner" class="amp-backdrop">
  <div class="amp-box">

    <div class="amp-header">
      <div class="amp-badge">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
        Indirizzi Multipli
      </div>
      <h3 class="amp-title"><span class="amp-partner-name">{{ selectedPartner.businessName }}</span> ha più indirizzi salvati</h3>
      <p class="amp-subtitle">Seleziona un indirizzo di ritiro per proseguire con questo ordine.</p>
    </div>

    <div class="amp-divider"></div>

    <div class="amp-default-block">
      <div class="amp-default-header">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
        <span>Indirizzo Predefinito</span>
        <span class="amp-default-tag">Predefinito</span>
      </div>
      <p class="amp-default-address">{{ selectedPartner.address }}</p>
    </div>

    <div class="amp-section-label">Seleziona un indirizzo alternativo</div>

    <div class="amp-list">
      <label
        *ngFor="let addr of selectedPartner.pickupAddresses"
        class="amp-item"
        [class.amp-item--selected]="selectedPickupAddress === addr"
        [class.amp-item--disabled]="isConfirming">
        <input
          type="radio"
          [value]="addr"
          [(ngModel)]="selectedPickupAddress"
          [disabled]="isConfirming">
        <div class="amp-radio-dot">
          <div class="amp-radio-inner"></div>
        </div>
        <div class="amp-address-text">
          <span class="amp-address-label">{{ addr }}</span>
        </div>
        <svg class="amp-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
      </label>
    </div>

    <div class="amp-footer">
      <button type="button" class="amp-btn amp-btn--cancel" (click)="handleModalBox()" [disabled]="isConfirming">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        Annulla
      </button>
      <button type="button" class="amp-btn amp-btn--confirm" (click)="confirmCustomPickUpAddress()" [disabled]="isConfirming || !selectedPickupAddress">

        <span *ngIf="isConfirming" class="amp-spinner"></span>

        <ng-container *ngIf="!isConfirming">
          Conferma Indirizzo
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </ng-container>

        <ng-container *ngIf="isConfirming">
          Caricamento...
        </ng-container>

      </button>
    </div>

  </div>
</div>